import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useTestDomainStatus(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);
  const mutation = $api.useMutation("post", "/shops/{shopId}/preferences/notifications/domains/check-status");

  return useMutation({
    onError: () => {
      errorNotification();
    },
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    mutationFn: async () => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id } },
      });
    },
  });
}
